export interface tgrMain {
    grpRtn: string //그룹 번호
    grpNm: string  //그룹명
    encp: string   //초대하기 shareKey 데이터
    newYn: string   //신규여부
    nextPage: string //브릿지 페이지에서 보낼 nextPage 값
	trnAblYn: string //이어가기여부
}

export const initialState: tgrMain = {
    grpRtn: '',
    grpNm: '',
    encp: '',
    newYn:'',
    nextPage: '',
	trnAblYn: '',
}
